import { z } from 'zod'
import { OcrResultSchema } from '../ocr.js'

export const OcrBatchResultItemSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('ok'), file_name: z.string(), ocr: OcrResultSchema }),
  z.object({ status: z.literal('error'), file_name: z.string(), error: z.string(), http_status: z.number().int() }),
])

export const OcrBatchResponseSchema = z.object({
  results: z.array(OcrBatchResultItemSchema),
})
export type OcrBatchResponse = z.infer<typeof OcrBatchResponseSchema>
export type OcrBatchResultItem = z.infer<typeof OcrBatchResultItemSchema>
